import { StatusRequestItineraryCheckIn } from 'src/types'

export function getStatusColor(status: StatusRequestItineraryCheckIn[]) {
  if (status.includes('expired')) return 'red'

  if (status.includes('pending')) return 'blue'

  if (status.includes('outside')) return 'orange'

  return 'green'
}
